import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'

interface INumberSelectorProps {
  selectedValue: number
  min: number
  max: number
  cellSuffix?: string
  width?: string
  fontSize?: string
  anyPlaceholder?: any
  placeholder?: string
  required?: boolean
  onChange: (value: number) => void
}

interface INumberSelectorState {
  value: number
}

class NumberSelector extends React.Component<INumberSelectorProps, INumberSelectorState> {
  state = {
    value: 0
  }

  componentDidMount() {
    const value = this.props.selectedValue
    this.setState({ value })
  }

  selectValue(value: number) {
    this.setState({ value })
    if (this.props.onChange) { this.props.onChange(value) }
  }

  render() {
    if (_.isUndefined(this.state.value)) { return null }
    const s1 = {
      display: 'inline-block',
      width: this.props.width || '270px'
    }
    const s2 = {
      backgroundColor: '#d0ffd0'
    }
    const paintPlaceholder = !!this.props.placeholder || !!this.props.anyPlaceholder
    const errorClass = this.props.required && (0 === this.state.value) ? ' has-error' : ''
    const classes = 'material-ageSelector-group hasValue' + errorClass
    return (
      <div className={classes} style={s1}>
        {paintPlaceholder && <label className="material-input-placeholder">{this.props.placeholder}{this.props.anyPlaceholder}</label>}
        <div style={s2}>
          {this.renderValue()}
        </div>
      </div>)
  }

  renderValue() {
    const value = this.state.value
    const values = _.range(this.props.min, this.props.max + 1)
    const fontSize = this.props.fontSize || '2em'
    return _.map(values, (v) => {
      const bingo = v === value
      const styles = {
        display: 'inline-block',
        fontSize,
        float: 'left'
      }
      const cellValue = this.props.cellSuffix ? v + this.props.cellSuffix : v
      const cls = bingo ? 'ageSelectorCurrent' : ''
      return <div style={styles} className={cls} key={v}>&nbsp;<a href="javascript:void(0)" onClick={() => this.selectValue(v)}>{cellValue}</a>&nbsp;</div>
    })
  }
}

export {
  NumberSelector
}



// WEBPACK FOOTER //
// ./src/app/components/form/NumberSelector/index.tsx